// extracted by mini-css-extract-plugin
module.exports = {"option":"SelectTypews_option__1Rkya"};